import { render, staticRenderFns } from "./CompSocialNetworkInteractions.vue?vue&type=template&id=06b3b609"
import script from "./CompSocialNetworkInteractions.vue?vue&type=script&setup=true&lang=js"
export * from "./CompSocialNetworkInteractions.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports